import { CurrencyPipe } from '@angular/common';
import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ParametrosService } from '../../../services/parametros.service';
import { solicitudJuridica } from '../../models/solicitud-juridica';
import { UserService } from '../../../services/user.service';
import { MicroempresarioService } from '../../services/microempresario.service';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BancoldexService } from '../../../comun/services/bancoldex.service';
import { redesSociales } from '../../models/redesSociales';
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { Localidad } from 'src/app/comun/models/localidad';
import { LOCALIDADES_BOGOTA } from 'src/app/comun/data/localidades-bogota';

//jQuery
declare var $: any;
const ParametroPlazoMinCreditoExpress = 'PAR-074';
const ParametroMontoMinimo = 'PAR-092';
const ParametroRedesSociales = 'PAR-095';
const ParametroFechaRegistroMinima = 'PAR-135';
const ParametroTextoFecha = 'PAR-136';
@Component({
    selector: 'solicitud-juridica-form',
    templateUrl: './solicitud.juridica.form.html',
    standalone: false
})
export class SolicitudJuridicaForm implements OnInit {
  @Output() event = new EventEmitter<any>();
  idEstadoSolicitud: number;
  juridicoForm: UntypedFormGroup;
  isSave: boolean = false;
  numSolicitud: string = '';
  titleModal: string = 'R';
  redesSociales: string[] = [];
  uno: number=1;
  cero: number=0;
  mensajeRedesSociales:string = null;
  fechaMinRegistro: number = null;
  mensajeFechaRegistro: string = null;
  //Selects
  departamentos: any[] = [];
  ciudades: any[] = [];
  sociedades: any[] = [];
  fechaActual: String = new Date().toLocaleDateString('en-CA');
  mensajeInformativo: String = null;
  rutaAchivo: String = null;
  observacionDevolucion: string = null;
  anios: any[] = [];
  montoMaximo: number = null;
  montoMinimo: number = null;
  mensajeError: string = null;
  plazoMinExpress: number = null;
  plazoMinError: string = null;
  mensajeMonto: string = null;
  mensajePlazo: string = "El plazo máximo permitido es de 180 meses.";
  //Fin selects
  hasValidator:number=0;
  camposLlenados:number=0;
  porcentajeVertical: number = 0;

  datosFormulario: string = 'credito';
  datosCliente: string = 'DatosNegocio';
  idPaisOrigen:number;
  // Variables campos invalidos
  isCredito: boolean = true;
  isCliente: boolean = true;
  isNegocio: boolean = true;
  isResidencia: boolean = true;
  isEconomicos: boolean = true;
  isMobile: boolean = true;
  seccionCredito = ['monto', 'plazo', 'destino'];
  seccionCliente = {
    DatosNegocio: ['razonSocial','correoElectronico'],
    DatosResidencia: ['idDepartamento','idCiudad','idLocalidad','barrioEmpresa','direccionEmpresa'],
    DatosEconomicos: ['creditoAnterior','fechaCreditoAnterior','idTipoSociedad','fechaRegistroActividadEconomica','anioActivos','nivelActivos','centralRiesgo'],
  };
  invalidControls: any[] = [];
  invalidSeccion: any[] = [];
  isSolicitudAnterior: boolean = false;
  readonly idBogota = 11001;
  localidades: ReadonlyArray<Localidad> = LOCALIDADES_BOGOTA;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private _parametro: ParametrosService,
    private _user: UserService,
    private _alert: AlertService,
    private _microempresario: MicroempresarioService,
    public pipe: CurrencyPipe,
    private _bancoldexService: BancoldexService,
    private _sweetAlert:SweetAlertService,
    private _router: Router
  ) {
    window.scroll(0, 0);
    this.getParametrosMonto();
    this.getPlazoMinimo();
    this.getMensajeRedesSociales();
    this.getFechaRegistroMinima();
    this.juridicoForm = this.formBuilder.group({
      idEmpresario: [0],
      solicitud: this.formBuilder.group({
        idSolicitud: [null],
        monto: ['', Validators.required],
        plazo: ['', Validators.required],
        idUsuario_NeoUsuario: [0],
        destino: ['', Validators.required],
      }),
      razonSocial: [{ value: '', disabled: true }, Validators.required],
      correoElectronico: [{ value: '', disabled: true }, Validators.required],
      idDepartamento: ['', [ Validators.required,Validators.min(1)]],
      idCiudad: ['', [ Validators.required,Validators.min(1)]],
      idLocalidad: [''],
      barrioEmpresa: ['', Validators.required],
      direccionEmpresa: ['', Validators.required],
      creditoAnterior: ['', Validators.required],
      fechaCreditoAnterior: [''],
      idTipoSociedad: [0, [Validators.required, Validators.min(1)]],      
      fechaRegistroActividadEconomica: ['', Validators.required],      
      anioActivos: [0, [Validators.required, Validators.min(1)]],
      nivelActivos: ['', Validators.required],     
      centralRiesgo: [false, [Validators.required, Validators.requiredTrue]],      
      red: ['']      
    });
    //estilos tooltip
    $(function () {
      $('[data-bs-toggle="tooltip"]').tooltip({
        boundary: 'window',
        template:
          '<div class="tooltip tooltip-custom" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      });
    });
  }

  ngOnInit() {
    this.getEnlaceDocumento();
    this.getDepartamentos();
    this.getTipoSociedad();
    this.setPipeForm();
    this.loadData();
    this.getMensajeInformativo();
    this.getAnios();
  }

  getAnios() {
    this._parametro
      .getAnios('juridico')
      .subscribe((data: any) => {
        this.anios = data.anios;
        this.anios = this.anios.filter(anio => anio != new Date().getFullYear()-2 &&  anio != new Date().getFullYear());
      });
  }

  getMensajeInformativo() {
    this._microempresario
      .getMensajeInformativo(this._user.getUser().tipoPersona)
      .subscribe((response) => {
        if (response['exitoso'] == true) {
          this.mensajeInformativo = response['mensaje'];
        }
      });
  }

  //Cargar selects
  getDepartamentos() {
    this._parametro
      .getDepartamentos('169')
      .subscribe((data: any) => (this.departamentos = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los departamentos');
      },
      () => {
        setTimeout(() => {
          $('#idCiudad').prop('disabled', true);
          $('.selectpicker').selectpicker('refresh');
        },300);
      });
  }

  getCambio(i){
    this.selectpikerChange('idDepartamento');
    this.juridicoForm.get('idCiudad').setValue('');
    $('.selectpicker').selectpicker('refresh');
    if(i.target.value != 0){
      this.getCiudades(i.target.value, false);
    }else{
      $('#idCiudad').prop('disabled', true);
      $('.selectpicker').selectpicker('refresh');
    }
  }

  getCiudades(idDepartamento: number, validar: boolean) {
    this._parametro
      .getCiudades(idDepartamento.toString())
      .subscribe((data: any) => (this.ciudades = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar las ciudades');
      },
      () => {
        setTimeout(() => {
          $('#idDepartamento').prop('disabled', validar);
          $('#idCiudad').prop('disabled', validar);
          $('#idLocalidad').prop('disabled', validar);
          $('.selectpicker').selectpicker('refresh');
        },300);
      });
  }

  getTipoSociedad() {
    this._parametro
      .getTipoSociedad()
      .subscribe((data: any) => (this.sociedades = data));
  }
  //Fin cargar selects

  addRed() {
    let red: any;
    if((this.juridicoForm.get('red').value).includes('https://')){
      red = `${this.juridicoForm.get('red').value}`.toLowerCase();
    }else{
        red = `https://${this.juridicoForm.get('red').value}`.toLowerCase();
    }
    if(this.redesSociales.indexOf(red) === -1){
      this.redesSociales.push(red);
      this.juridicoForm.get('red').setValue("");
    }
  }

  validateRed(key: string){
    const red = `https://${this.juridicoForm.get(key).value}`.toLowerCase();
    if(this.redesSociales.indexOf(red) !== -1){
      return true;
    }
  }

  deleteRed(index: number) {
    this.redesSociales.splice(index, 1);
  }

  loadData() {
    const idSolicitud = !this.route.snapshot.params.id
      ? null
      : this.route.snapshot.params.id;
    this._microempresario
      .cargarDatos({
        idEmpresario: +this._user.getUser().idEmpresario,
        idSolicitud: idSolicitud,
      })
      .subscribe((data: any) => {
        if (!data.solicitud) {
          const micro = data.Empresario;
          this.juridicoForm.get('razonSocial').setValue(micro.razonSocial);
          this.juridicoForm
            .get('correoElectronico')
            .setValue(micro.correoElectronico);
            if(micro.idDepartamento != null){
              this.juridicoForm.get('idDepartamento').setValue(micro.idDepartamento);
              this.getCiudades(micro.idDepartamento, true);
              this.juridicoForm.get('idCiudad').setValue(micro.idCiudad);
              this.juridicoForm.get('idLocalidad').setValue(micro.idLocalidad);
              $('#idDepartamento').selectpicker('refresh');
              $('#idCiudad').selectpicker('refresh');
              $('#idLocalidad').selectpicker('refresh');
            }else{
              this.juridicoForm.controls.idDepartamento.enable();
              this.juridicoForm.controls.idCiudad.enable();
              this.juridicoForm.controls.idLocalidad.enable();
              $('.selectpicker').selectpicker('refresh');
            }
          if (micro.fechaRegistroActividadEconomica) {
            this.juridicoForm
              .get('fechaRegistroActividadEconomica')
              .setValue(
                new Date(micro.fechaRegistroActividadEconomica)
                  .toISOString()
                  .slice(0, 10)
              );
          }
        } else {
          this.isSolicitudAnterior = [1,5].includes(data.solicitud.idEstadoSolicitud_NeoEstadoSolicitud);
          this.loadEmpresario(data.Empresario, data.solicitud);
          this.loadSolicitud(data.solicitud);
          this.loadRedesSociales(data.RedesSociales);
        }
        if (data.observacionDevolucion) {
          this.observacionDevolucion = data.observacionDevolucion;
        }
        if (this.juridicoForm.valid){
          this.isSave = true
        }
        this.calculoPorcentajeVertical();
      });
  }

  loadEmpresario(empresario: any, solicitud: any) {
    let contador:number=0;
    this.juridicoForm.get('razonSocial').setValue(empresario.razonSocial);
    this.juridicoForm.get('correoElectronico').setValue(empresario.correoElectronico);
    if (empresario.fechaRegistroActividadEconomica != null) {
      this.juridicoForm
        .get('fechaRegistroActividadEconomica')
        .setValue(
          new Date(empresario.fechaRegistroActividadEconomica)
            .toISOString()
            .slice(0, 10)
        );
    }
    if (empresario.idDepartamento != null && empresario.idDepartamento != 0) {
      this.juridicoForm.get('idDepartamento').setValue(empresario.idDepartamento);
      $('#idDepartamento').selectpicker('val', Number(empresario.idDepartamento));
      this.getCiudades(empresario.idDepartamento, true);
      this.juridicoForm.get('idCiudad').setValue(empresario.idCiudad);
      $('#idCiudad').selectpicker('val', Number(empresario.idCiudad));
      this.juridicoForm.get('idLocalidad').setValue(empresario.idLocalidad);
      $('#idLocalidad').selectpicker('val', Number(empresario.idLocalidad))
      $('.selectpicker').selectpicker('refresh');
    }else{
      this.juridicoForm.controls.idDepartamento.enable();
      this.juridicoForm.controls.idCiudad.enable();
      this.juridicoForm.controls.idLocalidad.enable();
      $('.selectpicker').selectpicker('refresh');
    }
    this.anios.forEach((elemento:any)=>{
      if(elemento != Number(empresario.anioActivos)){
        contador++
      }
    })
    if(contador>0){
      if(Number(empresario.anioActivos)!=0){
        this.anios.push(Number(empresario.anioActivos))
      }
    }
    if (this.isSolicitudAnterior) {
      this.juridicoForm.get('anioActivos').patchValue(Number(empresario.anioActivos));
      this.juridicoForm.get('nivelActivos').setValue(empresario.nivelActivos);
    }    
    this.juridicoForm.get('direccionEmpresa').setValue(empresario.direccionEmpresa);
    this.juridicoForm.get('idTipoSociedad').setValue(empresario.idTipoSociedad);
    this.juridicoForm.get('barrioEmpresa').setValue(empresario.barrioEmpresa);
    this.juridicoForm.get('creditoAnterior').setValue(empresario.creditoAnterior);
    if (!this.isSolicitudAnterior && solicitud.fechaDesembolso && empresario.creditoAnterior == 1) {
      this.juridicoForm.get('fechaCreditoAnterior').setValue(new Date(solicitud.fechaDesembolso).toISOString().slice(0, 10));
      this.setearValidadoresForm('fechaCreditoAnterior', [Validators.required]);
    } else if(empresario.creditoAnterior == 1){
      this.juridicoForm.get('fechaCreditoAnterior').setValue(new Date(empresario.fechaCreditoAnterior).toISOString().slice(0, 10));
      this.setearValidadoresForm('fechaCreditoAnterior', [Validators.required]);
    } else {
      this.juridicoForm.get('fechaCreditoAnterior').setValue('');
      this.setearValidadoresForm('fechaCreditoAnterior', null);
    }
  }

  loadRedesSociales(redesSociales: redesSociales[]) {
    redesSociales.forEach((redSocial) =>
      this.redesSociales.push(redSocial.url)
    );
  }

  loadSolicitud(solicitud: any) {
    this.idEstadoSolicitud = solicitud.idEstadoSolicitud_NeoEstadoSolicitud;
    this.juridicoForm.get('solicitud').get('monto').setValue(solicitud.monto);
    this.juridicoForm.get('solicitud').get('plazo').setValue(solicitud.plazo);
    this.juridicoForm.get('solicitud').get('destino').setValue(solicitud.destino);    
    this.juridicoForm.get('solicitud').get('idUsuario_NeoUsuario').setValue(solicitud.idUsuario_NeoUsuario);
    if(this.isSolicitudAnterior){
      this.juridicoForm.get('centralRiesgo').setValue(true);
      this._user.setIdSolicitud(solicitud.idSolicitud);
      this.juridicoForm.get('solicitud').get('idSolicitud').setValue(solicitud.idSolicitud);
    }    
    this.validarMonto();
    this.juridicoForm.markAllAsTouched();
  }

  saveForm() {
    var body = this.getJson(this.juridicoForm.value)
    if(this.isCreditoAnterior()){
      this._microempresario
      .saveSolicitud('juridico', body)
      .subscribe((data: any) => {
        if (data.exitoso) {
          this.juridicoForm.get('solicitud').get('idSolicitud').setValue(data.idSolicitudCredito);
          this.isSave = true;
          this._user.setIdSolicitud(data.idSolicitudCredito);
          if(this.juridicoForm.invalid){
            this.isSave = false;
            this.juridicoForm.markAllAsTouched();
            this._sweetAlert.infoModal("¡Solicitud en borrador!",false,
            'Tu solicitud ha sido guardada exitosamente. Diligencia correctamente los campos obligatorios antes de continuar con el cargue de documentos.'
            ).then((result) => {
              if (result.isConfirmed) {
                setTimeout(() => {
                  this.scrollToFirstError();
                }, 300);
              }
            });
          }else{
            this.isSave = true;
            this._sweetAlert.successModal("¡Éxito!",false,"Da clic en el botón “siguiente” para continuar con el cargue de documentos.").then((result) => {
              if (result.isConfirmed) {
                setTimeout(() => {
                  this.scrollToFirstError();
                }, 300);
              }
            });
          }
        } else {
          this._sweetAlert.errorModal("Error!",true,data.error);
        }
      });
      this.camposLlenados = 0;
      this.hasValidator = 0;
    } else {
      this.isSave = false;
    }    
  }

  getJson(form: solicitudJuridica) {
    const json = form;
    json.idEmpresario = +this._user.getUser().idEmpresario;
    json.idDepartamento = +json.idDepartamento;
    json.idLocalidad = json.idLocalidad ? +json.idLocalidad : null;
    json.idCiudad = +json.idCiudad;
    this.juridicoForm.get('idTipoSociedad').value == '0' ?
    json.idTipoSociedad = null : this.juridicoForm.get('idTipoSociedad').value;
    json.solicitud.monto = this.juridicoForm.get('solicitud').get('monto').value != null ?
    +this.juridicoForm.get('solicitud').get('monto').value.replace(/[,]/g, ''):0;
    json.solicitud.idUsuario_NeoUsuario = +this._user.getUser().idUsuario;
    json.nivelActivos = this.juridicoForm.get('nivelActivos').value != null ? +this.juridicoForm
      .get('nivelActivos')
      .value.replace(/[,]/g, ''):0;
    json.redesSociales = this.redesSociales;
    json.barrioEmpresa = this.juridicoForm.get('barrioEmpresa').value;
    json.direccionEmpresa= this.juridicoForm.get('direccionEmpresa').value;
    json.creditoAnterior = this.juridicoForm.get('creditoAnterior').value;
    json.fechaCreditoAnterior = this.juridicoForm.get('fechaCreditoAnterior').value
    json.camposObligatorios = this.getCamposObligatorios();
    json.camposLlenados = this.getCamposLlenados();
    return json;
  }

  goFiles() {
    if(this.juridicoForm.valid && this.isSave){
      let evento = { tipo: 'save', estado: this.idEstadoSolicitud ? this.idEstadoSolicitud : 1 };
      this.event.emit(evento);
    }else{
      this.juridicoForm.markAllAsTouched();
      // this._sweetAlert.errorModal("Error!",true,'Diligencia correctamente los campos obligatorios antes de continuar la solicitud.');
    }
  }

  validateField(key: string, item: string) {
    if (key === '') {
      return (
        this.juridicoForm.get(item).dirty && this.juridicoForm.get(item).invalid
      );
    } else {
      return (
        this.juridicoForm.get(key).get(item).dirty &&
        this.juridicoForm.get(key).get(item).invalid
      );
    }
  }

  //Validaciones form
  validateSelect(key: any) {
    if (key == '0') {
    }
  }

  validateCampo(key: string) {
    return (
      (this.juridicoForm.get(key).dirty ||
        this.juridicoForm.get(key)?.touched) &&
      this.juridicoForm.get(key)?.invalid
    );
  }

  validateLetters(event: any) {
    const pattern = /[a-zA-Z áéíóúÁÉÍÓÚñÑ@&._$-]+/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validateNumberPlazo(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    const pattern2 = /[0]/;
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    } else if (
      (Number(this.juridicoForm.get('solicitud.plazo').value) < 100 &&
        Number(this.juridicoForm.get('solicitud.plazo').value) == 18 &&
        !pattern2.test(inputChar)) ||
      (Number(this.juridicoForm.get('solicitud.plazo').value) > 18 &&
        pattern.test(inputChar))
    ) {
      event.preventDefault();
    }
  }

  showModal(title: string) {
    this.titleModal = title;
    // $('#politicasModal').modal('show');
  }

  setPipeForm() {
    this.juridicoForm.controls['nivelActivos'].valueChanges.subscribe(
      (data) => {
        if (data !== null) {
          this.juridicoForm.patchValue(
            {
              nivelActivos: this.pipe.transform(
                data.toString().replace(/\D/g, '').replace(/^/, ''),
                '',
                '',
                '1.0-0'
              ),
            },
            { emitEvent: false }
          );
        }
      }
    );
    this.juridicoForm.controls['solicitud']
      .get('monto')
      .valueChanges.subscribe((data) => {
        if (data !== null) {
          this.juridicoForm.patchValue(
            {
              solicitud: {
                monto: this.pipe.transform(
                  data.toString().replace(/\D/g, '').replace(/^0+/, ''),
                  '',
                  '',
                  '1.0-0'
                ),
              },
            },
            { emitEvent: false }
          );
        }
      });
  }

  getEnlaceDocumento() {
    var json = {
      idParametro: 'PAR-034',
      nombre: null,
      isParFuncional: false,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.rutaAchivo = String(respuesta[0].valorParametro);
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  validateForm() {
    var fechaRegistroMinima = new Date(this.juridicoForm.get('fechaRegistroActividadEconomica').value);
    fechaRegistroMinima.setMonth(fechaRegistroMinima.getMonth()+this.fechaMinRegistro);
    if (fechaRegistroMinima > new Date()) {
      this.juridicoForm.get('fechaRegistroActividadEconomica').setErrors({ incorrect: true });
      this._sweetAlert.errorModal("Error!",true,this.mensajeFechaRegistro);
      this.juridicoForm.markAllAsTouched();
    } else {
      this.saveForm();      
    }
    this.selectpikerChange('idDepartamento');
    this.selectpikerChange('idCiudad');
    this.selectpikerChange('idLocalidad');
    $("select").dropdown();
  }

  //Función para encontrar el campo siguiente en el formulario movil
  nextFieldMobile(field: string){
    const mobileContainer = document.querySelector('.d-block.d-xl-none');
    const element = mobileContainer.querySelector(`[formControlName="${field}"]`);
    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      (element as HTMLElement).focus();
    }, 100);
  }

  // Función para encontrar el primer campo inválido y desplazar la pantalla hacia él
  scrollToFirstError(): void {
    this.invalidControls = [];
    this.invalidSeccion = [];
    let timer = 0;
    this.findInvalidControl(this.juridicoForm);
    if (this.invalidControls.length === 0) {
      this.isCredito = this.isCliente = this.isNegocio = this.isResidencia = this.isEconomicos = true;
    } else {
      const firstInvalidControl = this.invalidControls[0].name;
      if (firstInvalidControl) {
        const mobileContainer = document.querySelector('.d-block.d-xl-none');
        const desktopContainer = document.querySelector('.d-none.d-xl-block');
        // Verifica cuál de los contenedores es visible
        const visibleContainer = this.isVisible(mobileContainer) ? mobileContainer : desktopContainer;
        if (visibleContainer == mobileContainer) {
          this.findSeccion(this.invalidControls);
          this.datosFormulario = this.invalidSeccion[0].split('.')[0];
          this.datosCliente = this.invalidSeccion[0].split('.')[1] ? this.invalidSeccion[0].split('.')[1] : 'DatosNegocio';
          this.isCredito = this.invalidSeccion.includes('credito') ? false : true;
          this.isCliente = this.invalidSeccion.some(seccion => seccion.startsWith('cliente')) ? false : true;
          this.isNegocio = this.invalidSeccion.includes('cliente.DatosNegocio') ? false : true;
          this.isResidencia = this.invalidSeccion.includes('cliente.DatosResidencia') ? false : true;
          this.isEconomicos = this.invalidSeccion.includes('cliente.DatosEconomicos') ? false : true;
          timer = 600;
        }
        if (visibleContainer) {
          // Busca el primer campo inválido dentro del contenedor visible
          const invalidControlElement = visibleContainer.querySelector(`[formControlName="${firstInvalidControl}"]`);
          if (invalidControlElement) {
            setTimeout(() => {
              // Desplaza la pantalla hacia el campo inválido
              invalidControlElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              (invalidControlElement as HTMLElement).focus();
            }, timer);
          }
        }
      }
    }
  }

  // Función para verificar si la pantalla visible es movil
  isVisible(element: Element | null): boolean {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  // Funcion para buscas los campos invaliddos en el formulario
  findInvalidControl(formGroup: UntypedFormGroup) {
    for (const controlName of Object.keys(formGroup.controls)) {
      const control = formGroup.get(controlName);
      if (control instanceof UntypedFormGroup) {
        // Si el control es un FormGroup, buscar recursivamente
        this.findInvalidControl(control);
      } else if (control?.invalid) {
        this.invalidControls.push({ name: controlName });
      }
    }
  }

  // Funcion para buscar las secciones de los campos invalidos
  findSeccion(controls: { name: string }[]) {
    const secciones = {
      credito: this.seccionCredito,
      cliente: this.seccionCliente
    };
    for (const control of controls) {
      const controlName = control.name;
      for (const [seccionPrincipal, valores] of Object.entries(secciones)) {
        if (Array.isArray(valores)) {
          // Si los valores son un array
          if (valores.includes(controlName)) {
            if (!this.invalidSeccion.includes(seccionPrincipal)) {
              this.invalidSeccion.push(seccionPrincipal);
            }
          }
        } else if (typeof valores === 'object') {
          // Si los valores son un objeto
          for (const [subSeccion, subValores] of Object.entries(valores)) {
            if (Array.isArray(subValores) && subValores.includes(controlName)) {
              const fullPath = `${seccionPrincipal}.${subSeccion}`;
              if (!this.invalidSeccion.includes(fullPath)) {
                this.invalidSeccion.push(fullPath);
              }
            }
          }
        }
      }
    }
  }

  isCreditoAnterior(){
    var creditoAnterior =  this.juridicoForm.get('creditoAnterior').value;
    if(creditoAnterior == '' || creditoAnterior == null){
      return true;
    }else{
      if(creditoAnterior == 1 && 
      (this.juridicoForm.get('fechaCreditoAnterior').value !='' &&
      this.juridicoForm.get('fechaCreditoAnterior').value !=null)){
        return true;
      }if(creditoAnterior == 0){
        this.juridicoForm.get('fechaCreditoAnterior').setValue('');
        return true;
      }else{
        this.juridicoForm.get('fechaCreditoAnterior').setErrors({ incorrect: true });
        return false;
      }
    }
  }

  cambioForm(){
    this.isSave = false;
    this.calculoPorcentajeVertical();
  }

  getParametrosMonto() {
    var json = {
      idParametro: 'PAR-057',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.montoMaximo = Number(respuesta[0].valorParametro);
        this.validarMonto();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
    var json = {
      idParametro: ParametroMontoMinimo,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.montoMinimo = Number(respuesta[0].valorParametro);
        this.validarMonto();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getPlazoMinimo(){
    var json = {
      idParametro: ParametroPlazoMinCreditoExpress,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.plazoMinExpress = Number(respuesta[0].valorParametro);
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getMensajeRedesSociales(){
    var json = {
      idParametro: ParametroRedesSociales,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeRedesSociales = respuesta[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal(error.error,true);
      }
    );
  }

  validarPlazo(){
    if(this.juridicoForm.get('solicitud').get('plazo').value){
      if(Number(this.juridicoForm.get('solicitud').get('plazo').value) < this.plazoMinExpress){
        this.juridicoForm.get('solicitud').get('plazo').setErrors({ incorrect: true });
        this.plazoMinError = "El plazo mínimo permitido es de " + this.plazoMinExpress + " meses.";
      }else{
        this.plazoMinError = "Campo obligatorio";
      }
    }
  }

  validarMonto() {
    let montoMinimo = this.pipe.transform(this.montoMinimo, 'USD', 'symbol', '0.0-0');
    let montoMaximo = this.pipe.transform(this.montoMaximo, 'USD', 'symbol', '0.0-0');
    this.mensajeMonto = "El monto máximo es de " + montoMaximo + " pesos.";
    if (this.juridicoForm.get('solicitud').get('monto').value) {
      if (Number(this.juridicoForm.get('solicitud').get('monto').value.replaceAll(',', '') > this.montoMaximo)) {
        this.juridicoForm.get('solicitud').get('monto').setErrors({ incorrect: true });
        this.mensajeError = "Campo obligatorio. El monto máximo es de " + montoMaximo + " pesos.";
      }
      if(Number(this.juridicoForm.get('solicitud').get('monto').value.replaceAll(',', '') < this.montoMinimo)){
        this.juridicoForm.get('solicitud').get('monto').setErrors({ incorrect: true });
        this.mensajeError = "Campo obligatorio. El monto mínimo es de " + montoMinimo + " pesos.";
      }
    }else{
      this.mensajeError = "Campo obligatorio";
    }
  }

  validarCreditoAnterior(valor:boolean){
    if(valor){
      this.setearValidadoresForm('fechaCreditoAnterior', [Validators.required])
    }else{
      this.setearValidadoresForm('fechaCreditoAnterior', null)
    }
  }

  setearValidadoresForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.juridicoForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.juridicoForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  selectpikerChange(field: string) {
    $(`#${field}`).selectpicker('destroy');
    let valid = this.validateCampo(field);
    if (!valid) {
      $(`#${field}`).removeClass('is-invalid');
    } else {
      $(`#${field}`).addClass('is-invalid');
    }
    $(`#${field}`).addClass('selectpicker');
    $(`#${field}`).selectpicker('render');
  }

  validarFechas() {
    let fechaIngresada = new Date();
    let fechaMinima = new Date();
    if (this.juridicoForm.get('fechaRegistroActividadEconomica').value) {
      fechaIngresada = new Date(this.juridicoForm.get('fechaRegistroActividadEconomica').value);
    }
    fechaMinima = new Date ("1900-01-01");
    if(fechaIngresada.getTime() < fechaMinima.getTime()) {
      this.juridicoForm.controls.fechaRegistroActividadEconomica.setErrors({
        incorrect: true,
      });
    } else {
      this.juridicoForm.controls.fechaRegistroActividadEconomica.setErrors(null);
    }
  }

  getCamposObligatorios():number{
    this.hasValidator = null;
    for (const field in this.juridicoForm.controls) { // 'field' is a string
      if(this.juridicoForm.get(field).validator != null){
        this.hasValidator++;
      }
      if(field=='solicitud'){
        for (let field2 in this.juridicoForm.get('solicitud')['controls']) {
          if(this.juridicoForm.get('solicitud')['controls'][field2].validator != null){
            this.hasValidator++;
          }
        }
      }
    }
    return this.hasValidator;
  }

  getCamposLlenados():number{
    this.camposLlenados = null;
    for (const field in this.juridicoForm.controls) { // 'field' is a string
      if(this.juridicoForm.get(field).validator != null){
        if(this.juridicoForm.get(field).value !== null && this.juridicoForm.get(field).value !== "" 
        && this.juridicoForm.get(field).value !== "0"){
          this.camposLlenados++;
        }
      }
      if(field=='solicitud'){
        for (let field2 in this.juridicoForm.get('solicitud')['controls']) {
          if(this.juridicoForm.get('solicitud')['controls'][field2].validator != null){
            if(this.juridicoForm.get('solicitud')['controls'][field2].value !== null &&
              this.juridicoForm.get('solicitud')['controls'][field2].value !==  0 &&
              this.juridicoForm.get('solicitud')['controls'][field2].value !== ""){
              this.camposLlenados++;
            }
          }
        }
      }
    }
    return this.camposLlenados;
  }

  calculoPorcentajeVertical(){
    if(this.getCamposLlenados() <= this.getCamposObligatorios()){
      this.porcentajeVertical = Math.round((this.getCamposLlenados()/this.getCamposObligatorios())*100);
    } else {
      this.porcentajeVertical = 100;
    }
  }

  validateNumberMonto(event: any) {
    let montoMaximo = this.pipe.transform(this.montoMaximo, 'USD', 'symbol', '0.0-0');
    const pattern2 = /[0]/;
    let inputChar = String.fromCharCode(event.charCode);
    let stringMontoMax = this.montoMaximo.toString();
    const patterMax = +stringMontoMax.substring(0, stringMontoMax.length - 1);
    if (this.juridicoForm.get('solicitud.monto').value != null) { 
       if ((Number(this.juridicoForm.get('solicitud.monto').value.replaceAll(',', '') == patterMax) &&
        !pattern2.test(inputChar)) || (Number(this.juridicoForm.get('solicitud.monto').value.replaceAll(',', '') > patterMax))) {
        event.preventDefault();
      }
    }
  }

  getFechaRegistroMinima() {
    var json = {
      idParametro: ParametroFechaRegistroMinima,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.fechaMinRegistro = Number(respuesta[0].valorParametro);
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
    var json = {
      idParametro: ParametroTextoFecha,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeFechaRegistro = respuesta[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }
}
